import { AfterViewInit, Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { SafeResourceUrl } from '@angular/platform-browser';
import { PdfService } from '../../../services/pdf.service';
import { MedicalServiceService } from '../../../services/medical-service.service';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { getBaseUrl } from '../../../app.module';
import { ResizedEvent } from 'angular-resize-event';
import { NotificationToastService } from '../../../services/notification-toast.service';
import { DownloadLocalFileService } from '../../../services/download-local-file.service';
import { ReportViewer } from '../../../model/report-viewer';
import { PrescriptionService } from '../../../services/prescription.service';
declare var tinymce: any;

export class PrescriptionDialogRequest {
  medicalAppointmentId: number;
  protocol: string;
  patient: string;
  patientAge: string;
  prescriptionIds: number[];
}

export class PrescriptionDialogResponse {
  delete: boolean;
  id: number;
}

@Component({
  selector: 'app-prescription-dialog',
  templateUrl: './prescription-dialog.component.html',
  styleUrls: ['./prescription-dialog.component.css']
})
export class PrescriptionDialogComponent implements OnInit {

  isView: boolean;
  reportViewer: ReportViewer;
  converting: boolean;
  deleting: boolean;
  safeResourceUrl: SafeResourceUrl;
  vertical = true;
  editing = true;
  loading: boolean;
  widthExp = 800;
  heightExp = 800;
  content;
  prescriptionId;
  isDownloadAll: boolean;


  constructor(public dialogRef: MatDialogRef<PrescriptionDialogComponent>
    , private pdfService: PdfService
    , private prescriptionService: PrescriptionService
    , private notificationToastService: NotificationToastService
    , private downloadLocalFileService: DownloadLocalFileService
    , @Inject(MAT_DIALOG_DATA) public data: PrescriptionDialogRequest) {
  }

  change(text) {
    this.content = text;
  }

  ngOnInit() {

  }

  onNoClick(): void {
    this.dialogRef.close(null);
  }

  getSafeResourceUrl(): SafeResourceUrl {
    return this.safeResourceUrl;
  }

  add(): void {
    this.prescriptionId = null;
    this.isView = false;
    this.editing = true;
  }

  async view(prescriptionId: number) {

    try {
      this.editing = false;
      this.converting = true;
      this.isView = true;
      this.prescriptionId = prescriptionId;
      this.reportViewer = await this.prescriptionService
        .getPrescriptionReportPdfById(prescriptionId);
      const pdfUrl = this.pdfService.base64ToPdfUrl(this.reportViewer.ReportBase64);
      this.safeResourceUrl = this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl);
      this.editing = false;
    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Prescripción');
    } finally {
      this.converting = false;
    }

  }

  async preView() {

    if ( this.content ) {
      try {
        this.converting = true;
        this.editing = false;
        this.reportViewer = await this.prescriptionService
          .getPrescriptionReportPdf(this.data.medicalAppointmentId, this.content);
        const pdfUrl = this.pdfService.base64ToPdfUrl(this.reportViewer.ReportBase64);
        this.safeResourceUrl = this.pdfService.pdfUrlToPdfSafeResourceUrl(pdfUrl); 
      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Prescripción');
      } finally {
        this.converting = false;
      }
    }

  }

  async delete() {
    if ( this.prescriptionId ) {
      try {
        this.deleting = true;
        await this.prescriptionService.delete(this.prescriptionId);
        const index = this.data.prescriptionIds.findIndex(p => p === this.prescriptionId);
        this.data.prescriptionIds.splice(index, 1);
        this.add();
      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Prescripción');
      } finally {
        this.deleting = false;
      }
    }
  }

  async aceptar() {

    if ( this.content ) {
      try {
        this.converting = true;
        const id = await this.prescriptionService
          .create(this.data.medicalAppointmentId, this.content);
        this.downloadLocalFileService
        .downLoadFile(this.reportViewer.ReportBase64, 'prescripción', 'pdf'); 
        this.data.prescriptionIds.push(id);
        this.content = null;
        this.add();

      } catch ( err ) {
        this.notificationToastService.error(JSON.stringify(err.error), 'Prescripción');
      } finally {
        this.converting = false;
      }
    }
  }

  async downloadAll() {
    try {
      this.isDownloadAll = true;
      const reports = await this.prescriptionService
        .getPrescriptionReportsBase64ByMedicalAppointmentId(this.data.medicalAppointmentId);
        let id = 1;
        reports.forEach(report => {
          this.downloadLocalFileService
          .downLoadFile(report.ReportBase64, 'prescripción-' + id, 'pdf');
          id = id + 1; 
        })
    } catch ( err ) {
      this.notificationToastService.error(JSON.stringify(err.error), 'Prescripción');
    }  finally {
      this.isDownloadAll = false;
    }
  }

  volver() {
     this.add();
  }

  onResized(event: ResizedEvent): void {
    this.widthExp = event.newWidth;
    this.heightExp = event.newHeight;
  }


}
